import { UserProfileVoData } from "./user-profile-vo-data";
import { UserActivationVoStatus } from "./user-activation-vo-status";
import { UserRegistrationVoStatus } from "./user-registration-vo-status";
import { UserCalendarOptionsVoData } from "./user-calendar-options-vo-data";
import { UserWorkTimerVoData } from "./user-work-timer-vo-data";
import { UserStatusVoData } from "./user-status-vo-data";
import { AddressVoData } from "../..";
var UserVoData = /** @class */ (function () {
    function UserVoData(id, category) {
        this.id = id;
        this.organizationId = null;
        this.loginName = null;
        this.category = category;
        this.profile = new UserProfileVoData();
        this.activationStatus = UserActivationVoStatus.DISABLED_BY_SYSTEM;
        this.registrationStatus = UserRegistrationVoStatus.INVITATION_SENT;
        this.customFields = [];
        this.address = new AddressVoData(-1);
        this.userCalendarOptions = new UserCalendarOptionsVoData(-1);
        this.userWorkTimer = new UserWorkTimerVoData(-1);
        this.status = UserStatusVoData.OFFLINE;
    }
    Object.defineProperty(UserVoData.prototype, "uid", {
        get: function () {
            return this.id;
        },
        enumerable: true,
        configurable: true
    });
    return UserVoData;
}());
export { UserVoData };
//# sourceMappingURL=user-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/user/user-vo-data.js
// module id = 953
// module chunks = 14